import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Tag } from '@im/ui-lib/Tag';
import { StaticDatePicker } from '../StaticDatePicker/StaticDatePicker';
import HeaderButtons from './DealDetailsPageHeaderButtons';
import { DeatilsResponse } from '../../hooks/deal-details';
import DealDetailsPageSubHeader from './DealDetailsPageSubHeader';
import DealDeatailsPageEditReseller from './DealDeatailsPageEditReseller';
import DealDeatailsPageEditEndUser from './DealDeatailsPageEditEndUser';
import { useSearchParams } from 'react-router-dom';
import { useTranslate } from '@im/react-localization';
import { StyledText, StyledTextSub } from 'src/components/StyledTypography';
import { EndUserSearchResponse } from '../../hooks/exceptionDeal';

export default function DealDetailsPageHeader(
  props: Readonly<{
    countryCode: string;
    data: DeatilsResponse | undefined;
    dealStatus?: string;
    exception: boolean;
    role: boolean;
    setIsOpenPopup?: React.Dispatch<React.SetStateAction<boolean>>;
  }>
) {
  const [searchParams] = useSearchParams();
  const translate = useTranslate();
  const [openDrawer, setOpenDrawer] = useState<
    false | 'edit-reseller' | 'edit-enduser'
  >(false);
  const [datePickerType, setDatePickerType] = useState<
    'Effective' | 'Expiration' | null
  >(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const details = props.data;
  const edResellerId =
    searchParams.get('edResellerId') ?? details?.reseller_number;
  const edAcopEndUserId =
    searchParams.get('edAcopEndUserId') ?? details?.end_user_number;
  const [isMiamiChecked, setIsMiamiChecked] = useState(false);
  const cmpEndUserId =
    searchParams.get('cmpAcopEndUserId') ?? details?.cmp_end_user_id;
  const [endUserOptionSelected, setEndUserOptionSelected] =
    useState<EndUserSearchResponse | null>(null);

  return (
    <Box>
      <Stack
        alignContent="center"
        direction={'row'}
        justifyContent="space-between"
      >
        <Stack alignContent="center" direction="row" spacing={1}>
          <Stack>
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.h6.fontSize,
                fontWeight: theme.typography.fontWeightSemiBold,
              })}
            >
              {details?.deal_number}
            </Typography>
            <Stack alignContent="center" direction="row" spacing={1}>
              {details?.dealDisplayNumber && (
                <Stack alignItems="center" direction="row" spacing={0.2}>
                  <StyledTextSub>
                    {`${translate('VendorProgram.TransactionalBidNumber')}:`}
                  </StyledTextSub>
                  <StyledText fontWeight={600}>
                    {details?.dealDisplayNumber}
                  </StyledText>
                </Stack>
              )}
              {details?.orderNumber && (
                <Stack alignItems="center" direction="row" spacing={0.2}>
                  <StyledTextSub>
                    {`${translate('VendorProgram.IMFOrderNumber')}:`}
                  </StyledTextSub>
                  <StyledText fontWeight={600}>
                    {details?.orderNumber}
                  </StyledText>
                </Stack>
              )}
            </Stack>
          </Stack>

          <Tag
            label={translate('VendorProgram.VersionNumber', {
              version: details?.version,
            })}
          />
          {details?.orderable && details.orderable !== '' && (
            <Tag
              label={
                details?.orderable === 'Y'
                  ? translate('VendorProgram.Orderable')
                  : translate('VendorProgram.NonOrderable')
              }
              variant={details?.orderable === 'Y' ? 'success' : 'warning'}
            />
          )}
          {details?.businessType && (
            <Box
              onClick={() => props.setIsOpenPopup?.(true)}
              sx={{ cursor: 'pointer' }}
            >
              <Tag label={details.businessType} />
            </Box>
          )}

          {details?.vendor_discount_type &&
            details.vendor_discount_type !== '' && (
              <Tag label={details.vendor_discount_type} />
            )}

          {details?.isXcmVendor && details.isXcmVendor && (
            <Tag label={translate('VendorProgram.XcmVendor')} />
          )}
        </Stack>
        <HeaderButtons
          countryCode={props.countryCode}
          dealStatus={props.dealStatus}
          details={details}
          edAcopEndUserId={edAcopEndUserId}
          edResellerId={edResellerId}
          endUserOptionSelected={endUserOptionSelected}
          exception={props.exception}
          isMiamiChecked={isMiamiChecked}
          role={props.role}
          setIsMiamiChecked={setIsMiamiChecked}
        />
      </Stack>
      <DealDetailsPageSubHeader
        cmpEndUserId={cmpEndUserId}
        dealStatus={props.dealStatus}
        details={details}
        edAcopEndUserId={edAcopEndUserId}
        edResellerId={edResellerId}
        exception={props.exception}
        role={props.role}
        setAnchorEl={setAnchorEl}
        setDatePickerType={setDatePickerType}
        setOpenDrawer={setOpenDrawer}
      />

      {Boolean(anchorEl) && (
        <StaticDatePicker
          anchorEl={anchorEl}
          countryCode={props.countryCode}
          data={details}
          datePickerType={datePickerType}
          setAnchorEl={setAnchorEl}
          setDatePickerType={setDatePickerType}
        />
      )}

      {openDrawer === 'edit-reseller' && details?.statusid !== 17 && (
        <DealDeatailsPageEditReseller
          details={details}
          handleClose={() => setOpenDrawer(false)}
          role={props.role}
        />
      )}

      {openDrawer === 'edit-enduser' && details?.statusid !== 17 && (
        <DealDeatailsPageEditEndUser
          countryCode={props.countryCode}
          details={details}
          edResellerId={edResellerId}
          handleClose={() => setOpenDrawer(false)}
          isMiamiChecked={isMiamiChecked}
          setEndUserOptionSelected={setEndUserOptionSelected}
          setIsMiamiChecked={setIsMiamiChecked}
        />
      )}
    </Box>
  );
}
